/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const CatalogItemId = zod
  .uuid()
  .describe("Identity shared by Material and Service Catalog Items.");

export type CatalogItemId = zod.input<typeof CatalogItemId>;
export type CatalogItemIdOutput = zod.output<typeof CatalogItemId>;
